import './App.css';
import { Leaderboard } from './Leaderboard';

function App() {
  return (
    <div className="App">
      <header className="App-header">
        <Leaderboard/>
      </header>
    </div>
  );
}

export default App;
